import $ from "jquery";
import DeleteConfirmationCell from "./DeleteConfirmation";
import RemoveRowCellRenderer from "./RemoveRowCellRenderer";

export default class RemoveRowWithConfirmationCellRenderer extends RemoveRowCellRenderer {
    onRemoveClick(cell) {
        const row = cell.getRow();
        this._hideCells(row)
        if (row.isEmpty()) {
            row.getTable().removeRowPermanently(row.getRowIdx())
            return
        }
        if (!row.confirmDialog)
            row.confirmDialog = new DeleteConfirmationCell($(row.getRowEl()), "userlist.userdata.effective_date_row_delete_confirmation", {
                onConfirm: () => {
                    $(row.getTable()).trigger("rowDeleted", [row]);
                },
                onCancel: () => {
                    this._showCells(row);
                }
            }).init();
    }

    _showCells(row) {
        row.setDeleteConfirmation(false);
        row.updateUI();
    }

    _hideCells(row) {
        row.setDeleteConfirmation(true);
        row.updateUI();
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/RemoveRowWithConfirmationCellRenderer.js